import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// loading
const loading = () => <div className="text-center">Loading...</div>;

class NonAuthLayout extends Component {
	static propTypes = {
		children: PropTypes.node,
	}

	render() {
		const children = this.props.children || null;
		return (
			<Suspense fallback={loading()}>
				{children}
			</Suspense>
		);
	}
}

export default connect()( NonAuthLayout );
